'use strict';
class DeveloperAnalyticsController {

    constructor($window, SSUtilService, SSAlertService, SSAnalyticsService, SSUserService) {
        const self = this;

        self.$window = $window;

        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSAnalyticsService = SSAnalyticsService;
        self.SSUserService = SSUserService;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        //self.SSAnalyticsService.loadCharts();
    }

    open(url) {
        const self = this;

        if (!url)
            return;

        // include current URL querystring
        if (self.$window.location.search) {
            if (url.indexOf('?') == -1) {
                url = url + self.$window.location.search;
            } else {
                url = url + '&' + self.$window.location.search.substring(1);
            }
        }

        // Handle API base url
        if (startsWith(self.$window.location.pathname, '/api/1.0/sec/')) {
            url = '/api/1.0/sec' + url;
        } else if (startsWith(self.$window.location.pathname, '/api/1.0/')) {
            url = '/api/1.0' + url;
        }

        // Open it
        self.$window.location.href = url;
    }

}

DeveloperAnalyticsController.$inject = ['$window', 'SSUtilService', 'SSAlertService', 'SSAnalyticsService', 'SSUserService'];
app.controller('DeveloperAnalyticsController', DeveloperAnalyticsController);